// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"288":"0beada175b26a099","615":"94af7e2a6240feff"}[chunkId] + ".js";
};